import {hydrateProduct} from './the-rail-catalog.js?v=1790971418318';

class TheRailTeaser extends HTMLElement {
  connectedCallback() {
    if(this.lifecycle)return;
    this.lifecycle=new AbortController();
    const {signal}=this.lifecycle;
    this.$=key=>this.querySelector(`[data-rail="${key}"]`);
    this.data={strings:{}};this.t=key=>this.data.strings[key]||'';
    this.observers=[];this.failed=false;this.starting=false;this.near=false;this.attempt=0;
    this.dataset.ready='false';this.invalidData=false;
    try{this.data=JSON.parse(this.querySelector('[data-rail-data]').textContent);}catch{this.invalidData=true;this.setState('failed');return;}
    const poster=this.$('loading-poster');
    this.dataset.posterValid=String(Boolean(poster)&&this.data.products.filter(product=>product.photos?.views).map(product=>product.handle).join(',')===poster.dataset.handles);
    this.defaultLabel();this.setState('loading');
    this.$('teaser-retry')?.addEventListener('click',()=>{this.querySelector('.rail-teaser__primary')?.focus({preventScroll:true});this.failed=false;this.starting=false;this.startScene(signal);},{signal});
    this.addEventListener('rail:failed',()=>this.fail(),{signal});

    // campaign-rail is the NEXT section. Its negative margin pulls its card up
    // into this reserved blank tail, never into the Rail's controls or garments.
    const shell=this.closest('.shopify-section')||this.parentElement;
    const next=shell.nextElementSibling;
    const campaign=next?.querySelector('[data-section-type="campaign-rail"]');
    const reserveSpace=()=>{
      const overlap=campaign?Math.max(0,-parseFloat(getComputedStyle(campaign).marginTop)||0):0;
      this.style.setProperty('--rail-overlap',`${overlap}px`);
    };
    reserveSpace();window.addEventListener('resize',reserveSpace,{signal});
    if(campaign){
      const observer=new ResizeObserver(reserveSpace);
      observer.observe(campaign);this.observers.push(observer);
    }
    if('IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>{
        this.near=entries.some(entry=>entry.isIntersecting);
        this.scene?.setRunning(this.near);
        if(this.near)this.startScene(signal);
      },{rootMargin:'200px'});
      observer.observe(this);this.observers.push(observer);
    }else{this.near=true;this.startScene(signal);}
  }
  async startScene(signal) {
    if(this.starting||this.scene||this.failed)return;
    const attempt=++this.attempt;this.setState('loading');
    this.starting=true;this.$('gallery').setAttribute('aria-busy','true');
    try{
      const products=this.data.products.map(hydrateProduct).filter(product=>product.views);
      if(!products.length){this.setState('empty');return;}
      const {createRailScene}=await import('./the-rail-scene.js?v=1790971418318');
      if(signal.aborted||attempt!==this.attempt)return;
      const scene=createRailScene(this,this.t,{mode:'teaser',onActivate:product=>window.location.assign(product.url)});
      this.scene=scene;
      await scene.start(products);
      if(signal.aborted||attempt!==this.attempt)return;
      scene.setRunning(this.near);
      this.$('pieces').hidden=false;this.setState('ready');
    }catch(error){
      if(!signal.aborted&&attempt===this.attempt){console.error('The Rail teaser',error);this.fail();}
    }finally{if(!signal.aborted&&attempt===this.attempt)this.starting=false;}
  }
  setState(state) {
    this.dataset.state=state;
    const status=this.$('teaser-status'),message=this.$('teaser-message'),retry=this.$('teaser-retry');
    if(status)status.hidden=state==='ready';
    if(message)message.textContent=state==='empty'?(status?.dataset.empty||this.t('empty_rail')):(state==='failed'?(this.t('failed')||status?.dataset.failed):this.t('loading'));
    if(retry)retry.hidden=state!=='failed'||this.invalidData;
    if(state==='empty'||state==='failed'){this.$('gallery').setAttribute('aria-busy','false');this.$('gallery').inert=false;}
  }
  defaultLabel() {
    const product=this.data.products.find(product=>product.photos?.views)||this.data.products[0];
    this.$('hover-title').textContent=product?.title||'';this.$('hover-price').textContent=product?.priceText||'';
  }
  fail() {
    const restoreFocus=this.contains(document.activeElement);
    this.attempt++;this.starting=false;this.setState('failed');
    this.scene?.destroy();this.scene=null;this.failed=true;this.dataset.ready='false';
    this.$('gallery').setAttribute('aria-busy','false');
    this.$('pieces').hidden=true;this.$('pieces').replaceChildren();
    this.defaultLabel();
    if(restoreFocus)this.$('teaser-retry')?.focus({preventScroll:true});
  }
  disconnectedCallback() {
    this.attempt++;
    this.lifecycle?.abort();this.lifecycle=null;
    this.observers?.forEach(observer=>observer.disconnect());
    this.scene?.destroy();this.scene=null;
    this.$?.('pieces')?.replaceChildren();
    this.$?.('pieces')?.setAttribute('hidden','');
  }
}
if(!customElements.get('the-rail-teaser'))customElements.define('the-rail-teaser',TheRailTeaser);
